import * as React from 'react'

import Styles from './ToggleButton.module.scss'
import cx from 'classnames'

interface Props {
  checked: boolean
  name: string
  handleChange: (e: React.ChangeEvent<any>) => void
  disabled?: boolean
  size?: 'normal' | 'small' | 'sm-md' | 'xs' | null
  isAPMobileWeb?: boolean
}

const ToggleButton = ({
  checked,
  name,
  handleChange,
  disabled = false,
  size = 'normal',
  isAPMobileWeb = false,
}: Props) => {
  return (
    <span onClick={(e) => e.stopPropagation()}>
      <input
        className={cx(Styles.checkbox, { [Styles.isAPMobileWeb]: isAPMobileWeb })}
        checked={checked}
        name={name}
        id={name}
        onChange={handleChange}
        type="checkbox"
        disabled={disabled}
        data-testid={name}
        aria-label={name}
      />
      <label
        className={cx(Styles.label, {
          [Styles.labelSmall]: size === 'small',
          [Styles.smMed]: size === 'sm-md',
          [Styles.xs]: size === 'xs',
        })}
        htmlFor={name}
      >
        <span
          className={cx(Styles.button, {
            [Styles.buttonSmall]: size === 'small',
            [Styles.smMed]: size === 'sm-md',
            [Styles.xs]: size === 'xs',
          })}
        />
      </label>
    </span>
  )
}

export default ToggleButton
